import React, { useState } from "react";
import { useProjectContext } from "../context";
import { projectOperationsList } from "../constants/project.constants";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { useGlobalContext } from "context/GlobalContext";
import { projectListColumnsL } from "../responsiveData/projectListColumnsL";
import { projectListColumnsS } from "../responsiveData/projectListColumnsS";
import { useNavigate } from "react-router-dom";
import { routeLinks } from "constants/paths";
import { useSelector } from "react-redux";
import { ReactTable } from "components/ReactTable/ReactTable";

export const ProjectList = () => {
  const { isMobile } = useGlobalContext();
  const { list, setCurrentOperationPage, setPreviewProject } =
    useProjectContext();
  const navigate = useNavigate();
  const handleOpenProducts = (row) => {
    navigate(routeLinks.projectManagementProject + "/" + row.id);
  };

  const handleRowClick = (row) => {
    setPreviewProject(row);
    setCurrentOperationPage(projectOperationsList.previewProject);
  };
  const handleTaskButtonClick = (row) => {
    setPreviewProject(row);
    setCurrentOperationPage(projectOperationsList.projectTask);
  };
  const handleEdit = (row) => {
    setPreviewProject(row);
    setCurrentOperationPage(projectOperationsList.updateProject);
  };
  const currentUserId = useSelector((state) => state.user.state.userId);
  const [selectedRowId, setSelectedRowId] = useState();
  return (
    <>
      <PageTitle pageName={pageName.project.projectList} />
      <div style={{ width: "100%" }}>
        <ReactTable
          columns={
            isMobile
              ? projectListColumnsS({
                  handleRowClick,
                  handleTaskButtonClick,
                  handleOpenProducts,
                  handleEdit,
                  currentUserId,
                })
              : projectListColumnsL({
                  handleRowClick,
                  handleTaskButtonClick,
                  handleOpenProducts,
                  handleEdit,
                  currentUserId,
                })
          }
          data={list}
          selectedRowId={selectedRowId}
          setSelectedRowId={setSelectedRowId}
        />
      </div>
    </>
  );
};
